var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.profile)?_c('record',{attrs:{"record":_vm.profile,"file-type":"customers"}}):_c('loading-spinner')],1)}
var staticRenderFns = []

export { render, staticRenderFns }